// extracted by mini-css-extract-plugin
module.exports = {"UserListHeading":"MainLayout_UserListHeading__1VyCL"};